/**
 * @generated SignedSource<<300bf84677d37baa1b921fd60bbdd33a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type actionCard_updateWorkItemFieldsActionRenderer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"cardFieldsList_updateWorkItemFieldsActionRenderer" | "cardHeader_updateWorkItemFieldsActionRenderer">;
  readonly " $fragmentType": "actionCard_updateWorkItemFieldsActionRenderer";
};
export type actionCard_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: actionCard_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionCard_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fieldIdsOrAliases"
    }
  ],
  "kind": "Fragment",
  "name": "actionCard_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "cardHeader_updateWorkItemFieldsActionRenderer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fieldIdsOrAliases",
          "variableName": "fieldIdsOrAliases"
        }
      ],
      "kind": "FragmentSpread",
      "name": "cardFieldsList_updateWorkItemFieldsActionRenderer"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "c0ee2fc906799fb2c515e6571cea18f3";

export default node;
